<template>
    <div class="modal" :class="{ 'is-active': isActive }">
        <div class="modal-background" @click="closeModal"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Please wright down chassis number!</p>
                <button class="delete" aria-label="close" @click="closeModal"></button>
            </header>
            <section class="modal-card-body">
                <figure class="image">
                    <img :src="bid.pictures.split('#')[0]">
                </figure>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Chassis</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <p class="control">
                                <input class="input" v-model="newBid.model_type_en" v-on:keyup="enableSubmit" type="text">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Shaken</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <div class="select is-fullwidth">
                                    <select v-model="shaken">
                                        <option :value="false">NO</option>
                                        <option :value="true">YES</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal" v-if="shaken">
                    <div class="field-label is-normal">
                        <label class="label">Shaken until</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" v-model="newBid.shaken_date" type="date">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">REC</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <div class="select is-fullwidth">
                                    <select v-model="rec">
                                        <option :value="false">NO</option>
                                        <option :value="true">YES</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal" v-if="rec">
                    <div class="field-label is-normal">
                        <label class="label">REC fee</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" v-model="newBid.rec_fee" type="number">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                        <label class="label">Lot #</label>
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input class="input" v-model="newBid.bid" type="text">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <label class="checkbox">
                                <input value="1" v-model="newBid.in_usd" type="checkbox">
                                In USD
                            </label>
                        </div>
                    </div>
                </div>
                <div class="field is-horizontal">
                    <div class="field-label is-normal">
                    </div>
                    <div class="field-body">
                        <div class="field">
                            <label class="checkbox">
                                <input value="1" v-model="newBid.remove_auction_sheet" type="checkbox">
                                Remove Auction Sheet
                            </label>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-success" :disabled="this.disableSubmit" @click="saveChanges" :class="{'is-loading' : isLoading}">Save changes</button>
                <button class="button" @click="closeModal">Cancel</button>
            </footer>
        </div>
    </div>
</template>

<script>
    import apiBids from './../../api/apiBids'
    export default {
        props: ['bid'],
        data() {
          return {
              shaken: false,
              rec: false,
              isLoading: false,
              disableSubmit: true,
              newBid: {
                  id: this.bid.id,
                  lot_id: this.bid.lot_id,
                  model_type_en: this.bid.model_type_en,
                  status: this.$bidStatusWin,
                  group_name: this.bid.group.name,
                  group_id: this.bid.group.id,
                  shaken_date: null,
                  rec_fee: null,
                  in_usd: null,
                  bid: this.bid.bid,
                  remove_auction_sheet: null
              }
          }
        },
        computed: {
            isActive: function () {
                return this.$store.getters.getResultModalStatus(this.bid.id)
            }
        },
        methods: {
            closeModal() {
                this.$store.dispatch('changeResultModalStatus', {status: false, bidId: ''})
            },
            enableSubmit () {
                if(this.newBid.model_type_en.length >= 10){
                    this.disableSubmit = false;
                }
            },
            saveChanges() {
                this.isLoading = true
                this.bid.model_type_en = this.newBid.model_type_en
                apiBids
                    .updateBidRequest(this.newBid)
                    .then((response) => {
                        this.isLoading = false
                        this.closeModal()
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            }
        },
        mounted () {
            this.enableSubmit()
        }
    }
</script>

<style scoped>
    .image {
        padding-bottom: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Bids/ResultModal.vue